import * as requestFromServer from './pasoUnoCrud';

import { pasoUnoSlice, callTypes } from './pasoUnoSclice';
//import { fetchInscripciones } from '../inscripcion/inscripcionActions';

const { actions } = pasoUnoSlice;

export const fetchPasoUnoAlDos = queryParams => async dispatch => {
    dispatch(actions.starCall({ callType: callTypes.action }));
    return await requestFromServer
        .postPasoUnoAlDos(queryParams)
        .then(response => {
            const pasoUnoAlDosInformacion = response.data;
            dispatch(actions.pasoUnoAlDosFetched({ pasoUnoAlDosInformacion }));
            //dispatch(fetchInscripciones());
        })
        .catch(error => {
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data.title || error.response.data);
            dispatch(actions.catchError({ error, callType: callTypes.action }));
        });
};

export const fetchPasoUnoAlCero = queryParams => async dispatch => {
    dispatch(actions.starCall({ callType: callTypes.list }));
    return await requestFromServer
        .postPasoUnoAlCero(queryParams)
        .then(response => {
            const pasoUnoAlCeroInformacion = response.data;
            dispatch(actions.pasoUnoAlCeroFetched({ pasoUnoAlCeroInformacion }));
        })
        .catch(error => {
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data.title || error.response.data);
            dispatch(actions.catchError({ error, callType: callTypes.list }));
        });
};

export const fetchResponsableInfromacion = queryParams => dispatch => {
    dispatch(actions.starCall({ callType: callTypes.list }));
    return requestFromServer
        .getResponsableInformacion(queryParams)
        .then(response => {
            const { posicion } = queryParams;
            const responsableInformacion = response.data;
            dispatch(actions.agregarUnResponsable({ responsableInformacion, posicion }));
        })
        .catch(error => {
            const { posicion } = queryParams;
            error.clientMessage = error.response && (error.response.data.mensaje || error.response.data.title || error.response.data);
            dispatch(actions.catchError({ error, callType: callTypes.list, posicion }));
        });
};

export const stateQuitarResponsables = queryParams => dispatch => {
    dispatch(actions.starCall({ callType: callTypes.list }));
    dispatch(actions.quitarResponsables({ queryParams }));
}

export const stateLimpiar = queryParams => dispatch => {
    dispatch(actions.stateLimpiar());
};